import Link from "next/link";
import { useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./index.module.scss";
import Offer from "/components/common/product/offer";
import Picture from "./picture";
import { formatType } from "../../../../utils";

export default function Product({ data }) {
  const { cityName } = useSelector((state) => state.location);
  const { sections } = useSelector((state) => state.sections);

  const images = data.PHOTOS_NEW?.map((pictureId) => {
    const path1 = pictureId.substr(0, 2);
    const path2 = pictureId.substr(2, 2);
    const path3 = pictureId.substr(4);
    return `/images/${path1}/${path2}/${path3}/small.webp`;
  });

  return (
    <div
      className={clsx(
        styles.ProductLanding,
        styles.Product,
        styles.ProductTable,
      )}
      itemScope
      itemType="http://schema.org/Product"
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        dataLayer.push({
          ecommerce: {
            currencyCode: "RUB",
            click: {
              products: [
                {
                  id: data.ID,
                  name: data.NAME,
                  price: data.CATALOG?.MIN_PRICE,
                  category: sections[data.IBLOCK_SECTION_ID].NAME,
                  brand: data.BRAND?.name,
                  list: "Каталог",
                },
              ],
            },
          },
        });
      }}
    >
      <div className={styles.Left}>
        <div className={styles.Photos}>
          {data.DETAIL_PAGE_URL && (
            <Picture
              stick={data.STICK}
              name={data.NAME}
              alt={`${data.NAME} ${data.ARTICLE?.VALUE} в ${cityName}`}
              link={data.DETAIL_PAGE_URL ?? "/"}
              video={data.VIDEO}
              path={data.DETAIL_PAGE_URL}
              images={images}
            />
          )}
        </div>
        <Link href={data.DETAIL_PAGE_URL ?? "/"}>
          <a className={styles.Name} itemProp="url">
            <span itemProp="name">{formatType(data.NAME)}</span>
          </a>
        </Link>
        <span style={{ display: "none" }} itemProp="description">
          {data.NAME}
        </span>
        <div className={styles.Info}>
          <div className={styles.Art}>Артикул {data.ARTICLE?.VALUE}</div>
        </div>
      </div>
      <Offer product={data} />
    </div>
  );
}
